import { ref, onMounted, onUnmounted, computed } from 'vue'

export function useScreen (breakpointSize = 0) {
  const MOBILE_VIEW = 900

  // Safe fallback for SSR (no `window` yet)
  const width = ref(0)
  const breakpoint = ref(breakpointSize)

  const onResize = () => {
    width.value = window.innerWidth
  }

  onMounted(() => {
    width.value = window.innerWidth
    window.addEventListener('resize', onResize)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', onResize)
  })

  const isMobileView = computed(() => width.value != 0 && width.value < MOBILE_VIEW)
  const isDesktopView = computed(() => width.value == 0 || width.value >= MOBILE_VIEW)
  const isBreakpointView = computed(() => width.value < breakpoint.value)

  return {
    isMobileView,
    isDesktopView,
    screenWidth: width,
    isBreakpointView,
    breakpoint
  }
}
